import React, { Component } from "react";
import * as Icon from "react-feather";

class FaqSearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: "",
        };
    }

    onQueryChange = (e) => {
        this.setState({ query: e.target.value });
    };

    onKeyDown = (e) => {
        if (e.key === "Enter" && this.state.query.trim() && !this.props.searching) {
            this.props.onSearch(this.state.query.trim());
        }
    };

    onSearchClick = () => {
        let { query } = this.state;
        if (query.trim() && !this.props.searching) {
            this.props.onSearch(query.trim());
        }
    };

    onClearSearch = () => {
        this.setState({ query: "" });
        this.props.onClearSearch();
    };

    render() {
        let { query } = this.state;
        let { searching, hasSearchResults } = this.props;

        return (
            <div className="faq-search">
                <div className="faq-search__input-row">
                    <div className="faq-search__input-wrapper">
                        <Icon.Search size={16} className="faq-search__input-icon" />
                        <input
                            className="faq-search__input"
                            type="text"
                            placeholder="Ask a question, e.g. 'How can I save time while creating engagements?'"
                            value={query}
                            onChange={this.onQueryChange}
                            onKeyDown={this.onKeyDown}
                            disabled={searching}
                        />
                        {hasSearchResults && (
                            <button
                                className="faq-search__clear-btn"
                                onClick={this.onClearSearch}
                                title="Clear search"
                            >
                                <Icon.X size={14} />
                            </button>
                        )}
                    </div>
                    <button
                        className="faq-search__btn"
                        onClick={this.onSearchClick}
                        disabled={searching || !query.trim()}
                    >
                        {searching ? (
                            <>
                                <span className="faq-search__spinner" />
                                Searching...
                            </>
                        ) : (
                            <>
                                <Icon.Zap size={14} />
                                AI Search
                            </>
                        )}
                    </button>
                </div>
            </div>
        );
    }
}

export default FaqSearchBar;
